import { Alert, useTheme } from "@mui/material";

const MaintenanceAlert = () => {
    const theme = useTheme();
    return (
        <Alert
            severity="error"
            sx={{
                height: "72px",
                borderRadius: "0px",
                [theme.breakpoints.up("md")]: {
                    paddingLeft: "132px"
                }
            }}
        >
            SCHEDULED MAINTENANCE - TUESDAY, SEPTEMBER 24, 2024, 6:00AM -
            10:00AM (EST) <br /> Our system will be temporarily unavailable on
            Tuesday, September 24, while we perform planned system maintenance
        </Alert>
    );
};

export default MaintenanceAlert;
